import React, { Component } from 'react';
import { withApollo } from 'react-apollo';
import styled, { css } from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import ga from '../utils/ga-tracker';
import { CREATE_VOX } from '../utils/graph-api';
import { t, tspan } from '../utils/i18n';
import { DirectUpload } from '@rails/activestorage';
import {TitleText} from './start';
import Waveform from "../components/waveform";
import {Play} from "./playback";
import WaveSurfer from "wavesurfer.js";
// import CursorPlugin from 'wavesurfer.js/dist/plugin/wavesurfer.cursor.min.js';
import SendVox from '../components/buttons/send';
import {ColoredFooter} from "./mic-check";
import {Back} from "../components/buttons/playback";
import { BottomText } from "./recording";
import { sendButton } from "../utils/alt-tags";


const queryString = require('query-string');

const ContactContainer = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;

    .checkbox {
        width: 50%;
        font-size: 0.875rem;

        &-label {
            color: rgb(68, 68, 68);
        }
    }

    .contact-form {
        margin-top: 1.75rem;
        display: flex;
        flex-direction: column;

        padding: 2rem 1.5rem;

        ${props => props.settings && props.settings.mode === 'sample' && css`border-color: 1px whitesmoke;`}

        ${props => props.pluginMode && css`
            padding: 0 1.5rem;
        `}

        .input-line {
            width: 100%;
            padding: 0.25rem 0rem;

            text-align: justify;
            font-size: 0.875rem;
            ${breakpoint('xs', 'sm')`
                font-size: 0.75rem;
            `}

            display: flex;
            flex-wrap: nowrap;

            span {
                flex: 1;
            }

            input {
                flex: 1;
                text-align: left;
            }
        }
    }

    .buttons {
        padding-bottom: 0rem;
    }

    .small-print {
        font-size: 0.5rem;
        line-height: 1rem;

        span {
            display: inline-block;
            max-width: 90%;
        }
    }

    button {
        height: 2.4rem;
        width: 35.5%;
        ${props => props.pluginMode && css`
            width: 75%;
        `}

        font-size: 0.8rem;
        border-radius: 0.18rem;
        border: none;
        outline: none;

        font-weight: 700;
        color: white;
    }
`;

export const PrivacyText = styled.p`
font-family: Titillium Web;
  font-size: 12px;
  line-height: 15px;
  font-style: normal;
  font-weight: normal;
  width: 74%;
  margin: auto;
  a{
  color: ${(props) => props.color ? props.color : '#2E394F' };
  font-weight: 600;
`;

export const FormGroup = styled.div`
  padding: 1px;
  margin-top: 3px;
  width: 98%;
  border: 1px solid lightgray;
  border-radius: 4px;
  &:hover {
  &>label {
  color: #2E394F;
  }
    border: 1px solid #2E394F !important;
  }
  &:focus-within {
  &>label {
  color: #2E394F;
  }
   border: 1px solid #2E394F !important;
}
  &>label {
    transform: scale(0.75);
    position: absolute;
    top: -11px;
    left: 9px;
    color: rgba(0, 0, 0, 0.54);
    padding-left: 3px;
    padding-right: 3px;
    background-color: white;
  }
`;

export const TextField = styled.input`
  font-size: .8125rem !important;
  border:none !important;
    width: 98%;
  height: 22px;
  padding-left: 5px;
  &:hover {
    border: none !important;
  }
  &:focus {
    border:none !important;
    box-shadow: none !important;
  }
`;
export const RequiredCheckBox = styled.div`
  text-align: center;
  button {
    background: transparent;
    border: none;
  }
  .settings-checkbox {
    width: 11px;
    margin-top: 7px;
}
`;


class ContactDetails extends Component {
    state = {
        fName: '',
        email: '',
        phone: '',
        consent: true,
        processing: false,
        channelToken: '-1',
        createdBy: 'Contact',
        createdById: -1,
        signedId: '',
        sourceType: '',
        voxContext: '',
        wavesurfer: null,
        playing: false,
        currentTime: 0,
        totalDuration: 0,

    }

    componentDidMount() {
        const {query} = queryString.parseUrl(window.location.href);
        if(query && query.reply === 'reply'){
            this.setState({
                sourceType: query.reply,
                createdBy: query.createdBy,
                createdById: query.createdById,
                email: query.contactEmail,
                phone: query.contactMobile,
                fName: query.contactName,
            });
        }
        // A blob-url on the prop is a must
        const { blob, url, settings: { common } } = this.props;
        if (url) {
            const wavesurfer = WaveSurfer.create({
                container: '#waveform',
                hideScrollbar: true,
                fillParent: true,
                scrollParent: false,
                barWidth: 4,
                barGap: 0,
                waveColor: '#C4C4C4',
                progressColor: common.linearGradient,
                interact: true,
                barHeight: 1.5, // the height of the wave
                barRadius: 4,
                partialRender: true,
                mediaType: 'audio',
                normalize: true,
                height: 102,
                // plugins: [
                //     CursorPlugin.create({
                //         opacity: 0.2,
                //         customShowTimeStyle: {
                //             'background-color': '#000',
                //             color: '#fff',
                //             padding: '22px',
                //             'font-size': '10px'
                //         }
                //
                //     })
                // ]
            });
            wavesurfer.loadBlob(blob);

            this.setState({ wavesurfer });
            setTimeout(() => {
                const timer = wavesurfer.getDuration();
                this.setState({
                  totalDuration: parseInt(timer),
                });
            }, 1500);
            wavesurfer.on('pause', () => {
                (wavesurfer.interact &&
                    this.setState({ playing: false })
                )
            });
            wavesurfer.on('finish', () => {
                this.setState({playing: false});
            })
        }
        if(query && query.reply === 'reply'){
            this.setState({ sourceType:  query.reply });
        }
        const wave = document.getElementById('waveform').getElementsByTagName( 'wave');
        if(wave[1] && navigator.userAgent.match(/Windows/i) && navigator.userAgent.match(/Chrome/i)) {
            wave[1].style.zIndex = '2';
        }
    }
    timeLimitString(secondsLimit) {

        let resultM = 0, // In minutes
            resultS = secondsLimit; // In seconds

        // Starting with 2 minutes
        if (resultS > 59) {
            resultM = Math.floor(resultS / 60); // In minutes
            resultS = resultS % 60; // Remainder seconds
        }
        resultS = Math.round(resultS);
        { resultS < 10 ? resultS ='0' + resultS : resultS = resultS }

        return `${resultM ? (resultM) : '00'}${resultS ? ':'+resultS : ':00'}`
    }

    onInputChange = ({ target }) => {
        this.setState({ [target.name]: (target.type === 'checkbox' ? target.checked : target.value) });
    }
    getTheCurrentTime = () => {
        const {wavesurfer} = this.state;
        const _this = this;
        if (wavesurfer) {
            wavesurfer.on('audioprocess', function () {
                if (wavesurfer.isPlaying() && parseInt(wavesurfer.getCurrentTime()) !== _this.state.currentTime) {
                    _this.setState({currentTime: parseInt(wavesurfer.getCurrentTime())})
                }
            });
        }
    };

    playClip() {
        const { wavesurfer } = this.state;
        // Pause the wave
        wavesurfer.playPause();
        // Force a re-render
        this.setState({ playing: wavesurfer.isPlaying() });
    }
    GoBack = () => {
        const {onSwitch} = this.props;
        onSwitch('recording')
    }
    revert() {
        const { onSwitch } = this.props;
        const { wavesurfer } = this.state;

        // Clean up
        wavesurfer.destroy();

        // Return to mic-check to initiate the flow
        onSwitch('mic-check', { countdown: 3 });
    }

    submitVox = async () => {
        const { wavesurfer } = this.state;

        if (ga.initialized)
            ga.f.event({
                category: 'interaction',
                action: 'submit'
            })
        const { settings: { recorder: recorderSettings } } = this.props;

        await this.setState({ processing: true });

        const { onSwitch, client, blob } = this.props;

        var file = new File([blob], new Date());
        const upload = new DirectUpload(file, `${process.env.REACT_APP_API_URL}/rails/active_storage/direct_uploads`, this);
        upload.create((error, blob) => {
            if (error) {
                alert(error);
            } else {
                const { fName, email, phone, channelToken, createdBy, createdById } = this.state;
                (async () => {
                    const { data } = await client.mutate({
                        mutation: CREATE_VOX,
                        variables: {
                            contentType: recorderSettings.contentType,
                            recordingUrl: blob.signed_id,
                            firstName: fName,
                            email: email,
                            mobile: phone,
                            channelToken: channelToken,
                            createdBy: createdBy,
                            createdById: parseInt(createdById, 10),
                            length: Math.floor(wavesurfer.getDuration()),
                        }
                    });
                    const { id } = data.createVox.vox
                    this.setState({ processing: false });
                    onSwitch('complete', { id });
                })();

            }
        });

    }

    toggleLoader = () => {
        this.setState({ processing: false })
    };


    render() {
        const { settings: { common }, pluginMode } = this.props;
        const {
            wavesurfer, playing, processing, currentTime, totalDuration
        } = this.state;
        this.getTheCurrentTime()
        return (
            <ContactContainer pluginMode={pluginMode}>
                <div className="content">
                    <div className="plugin-header">
                        <div className="title" style={{ wordBreak:'break-word', whiteSpace: 'pre-wrap'}}>
                            <TitleText>
                                {tspan('sendVoxTitle')}
                            </TitleText>
                        </div>
                    </div>
                    <div className="sub-title"
                         style={{
                             fontStyle: 'normal',
                             fontFamily: 'Titillium Web',
                             fontWeight: 'normal',
                             fontSize: '15px',
                             lineHeight: '23px',
                             color:'#27364E',
                             margin:`${pluginMode ? "10px 0" : "0"}`,
                             wordBreak:'break-word',
                             whiteSpace: 'pre-wrap',
                         }}>
                        {
                            tspan('plugin-playback-subTitle')
                        }
                    </div>
                    <div className="content-footer">
                        <Waveform details={false} pluginMode={pluginMode} toggleLoader={this.toggleLoader} play/>
                        <div style={{
                            display: 'flex',
                            width: '75%',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            margin:'0.5rem auto',
                        }}>
                            <i className=''  style={{visibility:'hidden'}}></i>
                            <Play size="2x" isPlaying={playing} onPlay={() => this.playClip()}/>
                            <label style={{fontFamily: 'Titillium Web',
                                display:'flex',
                                justifyContent:'flex-end',
                                fontSize: '10px',
                                lineHeight: '15px',
                                textAlign: 'right',

                            }}>{wavesurfer !== null &&  this.timeLimitString(currentTime)}
                                /
                                {wavesurfer !== null &&  this.timeLimitString(totalDuration)}
                            </label>

                        </div>
                        {common.privacyLinkRequired &&
                        <PrivacyText
                            color={common.buttonColor}
                        >Our <a href={common.isPublicHosted ? "https://blessourheroes.webflow.io/legal/privacy-policy" :
                            common.privacyLink ? common.privacyLink.includes('http' || 'https') ?
                                common.privacyLink : `https://${common.privacyLink}` : "https://www.telbee.io/privacy/"}
                                rel="noopener noreferrer" target="_blank">Privacy Policy</a> explains how we use and protect your personal information. Please read it before pressing send.
                        </PrivacyText>
                        }
                    </div>
                </div>
                {!common.privacyLinkRequired &&
                <BottomText>Press to proceed</BottomText>}
                <ColoredFooter className="buttons" requiredShadow={common.requiredShadow} hideGreyBar={common.hideGreyBar}>
                    <Back sendVox onBack={() => this.revert()}/>
                    {/* Submit button */}
                    <SendVox common={common} processing={processing} onClick={this.submitVox}
                             micPermission={true} title={sendButton}/>

                </ColoredFooter>
            </ContactContainer>
        );
    }
}

export default withApollo(ContactDetails);
